export default {
    intro: 'Listen carefully and write it down correctly!',
    wordIndex: 'Word {index}',
    student: {
        myAnswer: 'My Submitted Answer',
        noAnswer: 'No answer was submitted.',
        answer: 'Correct Answer',
        attemptNumber: 'Round {number}',
        listen: 'Listen carefully!<br />Pay close attention!',
        teacherReading: 'The Teacher is reading it aloud',
        listenDirect: 'Listen carefully to the sentence the Teacher is reading aloud!',
        placeholder: 'Please enter the correct answer.',
        wrongToast: "Oops, that's incorrect. Try entering it again.",
        writeEnd: 'End Writing',
        submitAnswer: 'Submit Answer',
        waitingStart: "Please wait for the Teacher's signal to start writing!",
        threeWrong: "You've used all 3 chances... Please wait for the Teacher to reveal the correct answer!",
    },
    teacher: {
        setting: {
            activity: 'Activity Content',
            number: 'Number',
            title: 'Dictation 📝',
            message: 'If you play the sentence now, Students may also hear it!',
            subMessage: 'Do you still want to play it?',
            optionSubMessage: 'After playing it once, this confirmation will not appear again.',
            confirmText: 'Play',
        },
        question: 'Question',
        intro: 'Please select a word from the questions on the left.',
        ttsStart: 'Play & Start Writing',
        directReading: 'Read Aloud',
        startWriting: 'Start Writing',
        completeWriting: 'Finish Writing & Reveal Answer',
        toast: {
            alreadyDone: 'This word has already been completed.',
            fiveSeconds: 'You can finish writing 5 seconds after starting.',
        },
        result: {
            title: 'Accuracy Per Question',
            order: 'Order',
            question: 'Question',
            answerRate: 'Accuracy',
        },
    },
    table: {
        question: 'Question',
        answerRate: 'Accuracy',
        emptyMessage: 'No content available.',
    },
};
